import { useEffect, useState } from 'react';

import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
// Utils
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import { dayOfWeek } from '@/lib/scheduler/calendar/calendar';

// Endpoints
import { SCHEDULER_TIME_SLOTS } from '@/routes/apiEndpoints';

const useTimeSlots = ({ options = {}, isGroup, activeGroup, activeSocialProfile } = {}) => {
    const [timeSlotsFormatted, setTimeSlotsFormatted] = useState(null);

    const fetcher = async (urls) => {
        const promises = urls.map((url) => get(url));
        return Promise.all(promises).then((res) => {
            return res.map((r) => r.data.data).flat();
        });
    };

    const {
        data,
        mutate,
        error: timeSlotsError
    } = useSWR(
        [
            isGroup
                ? activeGroup?.social_profiles
                      ?.filter((sp) => sp.active)
                      ?.map((sp) => {
                          return injectEndpointUrlParams(SCHEDULER_TIME_SLOTS, {
                              SPID: sp?.id
                          });
                      })
                : [
                      injectEndpointUrlParams(SCHEDULER_TIME_SLOTS, {
                          SPID: activeSocialProfile?.id
                      })
                  ]
        ],
        ([urls]) => fetcher(urls),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    useEffect(() => {
        const defaultData = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: []
        };
        if (data) {
            data.forEach((slot) => {
                slot.frequency.map((day) => {
                    const formatDay = dayOfWeek[day];
                    if (!defaultData[formatDay].find((item) => item.hour === slot.occurs_at)) {
                        defaultData[formatDay].push({ hour: slot.occurs_at, count: 1 });
                    } else {
                        defaultData[formatDay].find((item) => item.hour === slot.occurs_at).count++;
                    }
                });
            });
        }
        setTimeSlotsFormatted(defaultData);
    }, [data]);

    return {
        timeSlots: data,
        timeSlotsFormatted,
        mutateTimeSlots: mutate,
        timeSlotsError,
        isLoadingTimeSlots: !data && !timeSlotsError
    };
};

export default useTimeSlots;
